import NotesWithDate from "../../components/notes/NotesWithDate";
import type { FC } from "react";
import { useOrderNotes } from "../notes/useOrderNotes";
import { LinearProgress } from "@mui/material";

interface Props {
  readonly orderId: string;
  readonly contactDate: string | undefined;
}

const OrderCardNotes: FC<Props> = ({ orderId, contactDate }) => {
  const { notes, isLoading, addOrderNote } = useOrderNotes(orderId);
  if (isLoading) {
    return <LinearProgress />;
  }
  return (
    <NotesWithDate
      deleteDisabled
      notes={notes ?? []}
      onChange={async (notes, contactDate) => {
        await addOrderNote(notes[0].text, contactDate);
      }}
      contactDate={contactDate ?? null}
    />
  );
};

export default OrderCardNotes;
